export default __webpack_public_path__ + "static/media/Patrice_Strong-Register_AHV_In_Moms_We_Trust.f9e17a78.jpg";